import { Droplets, Gauge, ToggleRight, Cpu, Settings, Building2, Home as HomeIcon, Factory, Warehouse, Building, HardHat } from "lucide-react";

export const navLinks = [
  { label: "Home", href: "/#home" },
  { label: "Products", href: "/#products" },
  { label: "Clients", href: "/#clients" },
  { label: "About Us", href: "/#about" },
  { label: "Contact Us", href: "/#contact" },
];

export const heroData = {
  heading: "Reliable Water Level & Automation Solutions",
  subheading: "25+ years of experience in electrical control panels and automation systems.",
  ctaText: "View Products",
  ctaLink: "/products",
  backgroundImage: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3NzE0MjM5MDl8MA&ixlib=rb-4.1.0&q=85",
};

export const clientCategories = [
  { id: 1, label: "Residential Projects", Icon: HomeIcon },
  { id: 2, label: "Housing Societies", Icon: Building2 },
  { id: 3, label: "Commercial Buildings", Icon: Building },
  { id: 4, label: "Pump Houses", Icon: Warehouse },
  { id: 5, label: "Factories", Icon: Factory },
  { id: 6, label: "Industrial Clients", Icon: HardHat },
];

/** Spotlight product on the home page — edit copy or point `image` / `Icon` at another SKU. */
export const starProduct = {
  badge: "Our star product",
  title: "Automatic Pump Controller",
  highlight: "The smart way to protect pumps and never run dry",
  description:
    "Our flagship controller automates pump operation from tank levels, prevents dry running and overflow, and cuts manual switching—trusted in thousands of residential and commercial installations.",
  image: "waterlevelcontroller",
  Icon: Gauge,
  features: [
    "Automatic start/stop from real water level",
    "Dry-run and overflow protection built in",
    "Works with single- and three-phase motors",
    "Stable operation under voltage fluctuation",
  ],
  ctaText: "View product details",
  ctaLink: "/products",
};

/**
 * Home page marketing video (YouTube). Paste only the video ID from the URL:
 * https://www.youtube.com/watch?v=THIS_PART
 * Leave youtubeVideoId empty (null or "") until you have a video — a placeholder panel will show.
 */
export const marketingVideo = {
  title: "See it in action",
  subtitle:
    "A short walkthrough of real-world use—how our systems protect pumps and simplify water management.",
  youtubeVideoId: "En7YEkbnp7U",
};

export const products = [
  {
    id: 1,
    title: "Digital Water Level Indicator",
    shortDescription: "Real-time monitoring of water tank levels with LED display and audio alerts.",
    description: "Our Digital Water Level Indicator provides precise, real-time monitoring of water levels in overhead and underground tanks. Features an easy-to-read LED display with audible alerts when levels are critical.",
    image: "digitalwaterlevelindicator",
    Icon: Droplets,
    features: [
      "LED display for real-time water level",
      "Audio alert on overflow and dry run",
      "Compatible with overhead & underground tanks",
      "Low power consumption",
      "Easy installation and maintenance"
    ]
  },
  {
    id: 2,
    title: "Automatic Pump Controller",
    shortDescription: "Smart pump management that automatically controls water pump operations.",
    description: "The Automatic Pump Controller intelligently manages your water pump based on tank levels. It prevents dry running, overflow, and ensures optimal water supply without manual intervention.",
    image: "waterlevelcontroller",
    Icon: Gauge,
    features: [
      "Automatic ON/OFF based on water level",
      "Dry run protection",
      "Overflow prevention",
      "Compatible with single & three-phase motors",
      "Voltage fluctuation protection"
    ]
  },
  {
    id: 3,
    title: "Fire Panel",
    shortDescription: "Centralized fire detection and alarm system for safety and compliance.",
    description: "Our Fire Alarm Control Panel is designed to detect fire hazards early and trigger immediate alerts to ensure safety. It integrates with smoke detectors, heat sensors, and alarm systems to provide reliable fire protection for residential, commercial, and industrial environments.",
    image: "firepanel",
    Icon: ToggleRight,
    features: [
      "Compatible with smoke, heat, and flame detectors",
      "Automatic alarm triggering and notification system",
      "Manual call point integration for emergency activation",
      "Battery backup for uninterrupted operation",
      "LED indicators for zone-wise monitoring",
      "Supports hooters, sirens, and emergency lighting systems",
      "Complies with standard fire safety regulations"
    ]
  },
  {
    id: 4,
    title: "Motor Control Panel",
    shortDescription: "Custom-built motor control panels for industrial and commercial applications.",
    description: "Our Motor Control Panels are custom-designed for specific requirements. Built with high-quality components, they ensure reliable motor operation with comprehensive protection features.",
    image: "motorcontrolpanel",
    Icon: Cpu,
    features: [
      "Custom-built to specification",
      "Overload & short circuit protection",
      "Phase failure protection",
      "IP-rated enclosures",
      "Energy-efficient design"
    ]
  },
  {
    id: 5,
    title: "PLC Automation Panel",
    shortDescription: "Programmable logic controller panels for advanced industrial automation.",
    description: "Our PLC Automation Panels deliver advanced process automation for industrial applications. Programmable and scalable, they bring precision and efficiency to complex operations.",
    image: "plcpanel1",
    Icon: Settings,
    features: [
      "Programmable logic controllers",
      "SCADA integration ready",
      "Remote monitoring capability",
      "Scalable architecture",
      "Comprehensive I/O modules"
    ]
  }
];

export const companyInfo = {
  name: "Advanced Automation",
  tagline: "Precision. Reliability. Automation.",
  about: "Advanced Automation is a Delhi-based manufacturer of water level indicators, automatic pump controllers, and electrical control panels with over 25 years of experience serving residential, commercial, and industrial clients.",
  address: "1/3, DSIDC SHED COMPLEX, TIGRI, P.O. SANGAM VIHAR, NEW DELHI-110080 INDIA",
  phone: "011 4702    7401, 8700 919798",
  email: "aadelhi@hotmail.com",
  yearsExperience: 25,
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.01805607888!2d77.23520901164103!3d28.509104475631244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd309eebed77%3A0xa4becd45997cbeda!2sAdvanced%20Automation%20-%20Digital%20Level%20Indicator!5e0!3m2!1sen!2sus!4v1771690550675!5m2!1sen!2sus"
};

export const stats = [
  { value: "25+", label: "Years Experience" },
  { value: "5000+", label: "Systems Installed" },
  { value: "500+", label: "Happy Clients" },
  { value: "24/7", label: "Support Available" },
];
